import React from "react";
import { Button } from "antd";
import { RollbackOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

function Reset({
  id = "btn-reset",
  type = "primary",
  icon = <RollbackOutlined />,
  danger = true,
  title,
  ...props
}) {
  const { t } = useTranslation();

  const titleBtn = title ? title : t("button.reset");

  return (
    <Button id={id} type={type} icon={icon} danger={danger} {...props}>
      {titleBtn}
    </Button>
  );
}

export default Reset;
